import ProfileService from "../../../services/profile";
import { getDefaultProfile } from "./profileState";
import * as types from "./mutationTypes";
import { i18n } from "@/boot/i18n";
import removeMask from "@/utils/removeMask";
import ErrorHandler from "@/tools/errorHandler";
import { validators } from "./validators";

export default {
  initRegistrationState({ commit, dispatch }) {
    commit(types.SET_PROFILE, getDefaultProfile());
    const validator = validators();
    dispatch("validator/addValidator", validator.name, { root: true });
    dispatch("validator/addValidator", validator.phone, { root: true });
    dispatch("validator/addValidator", validator.offset, { root: true });
    dispatch("validator/addValidator", validator.language, { root: true });
    dispatch("validator/addValidator", validator.code, { root: true });
    dispatch("password/addPasswordValidators", null, { root: true });
  },
  clearRegistrationState({ commit, dispatch }) {
    commit(types.CLEAR_PROFILE);
    dispatch("validator/clearValidator", null, { root: true });
  },
  async getRegistrationEmail({ dispatch }, token) {
    try {
      const response = await ProfileService.getRegistrationEmail(token);
      if (response.data.data) {
        dispatch("setEmailSuccess", response.data.data.email);
      }
    } catch (error) {
      dispatch("setEmailError", error);
    }
  },
  async finishRegistration({ dispatch, state, rootState }, token) {
    const valid = await dispatch("validate");
    if (!valid) {
      return;
    }
    try {
      const data = { ...state.profile };
      data.phone = Number(removeMask(data.phone));
      data.primary_time_offset = Number(data.primary_time_offset);
      data.treatment = Number(data.treatment);
      data.password = rootState.password.password;

      await ProfileService.finishRegistration({ token, data });
      dispatch("ui/showToastSuccess", i18n.t("registration.messages.register_success"), { root: true });
      return true;
    } catch (error) {
      dispatch("ui/showToastError", ErrorHandler.getErrorMessage(error), { root: true });
      return false;
    }
  },
  setField({ commit, dispatch }, { field, value }) {
    commit(types.SET_FIELD, { field, value });
    dispatch("validator/checkValidation", { field, value: value }, { root: true });
  },
  setEmailSuccess({ commit }, email) {
    commit(types.SET_FIELD, { field: "email", value: email });
  },
  setEmailError({ dispatch }, error) {
    let message = "";
    switch (error.response.data.message.toLowerCase()) {
      case "missing registration token":
        message = i18n.t("registration.messages.invalid_token");
        break;
      case "invite already accepted":
        message = i18n.t("registration.messages.already_registered");
        break;
      default:
        message = i18n.t("registration.messages.get_email_error");
    }
    dispatch("ui/showToastError", message, { root: true });
  },
  validate({ dispatch, rootState, state }) {
    dispatch("validator/validate", { field: "name", value: state.profile.name }, { root: true });
    dispatch("validator/validate", { field: "phone", value: state.profile.phone }, { root: true });
    dispatch(
      "validator/validate",
      { field: "primary_time_offset", value: state.profile.primary_time_offset },
      { root: true }
    );
    dispatch("validator/validate", { field: "country_code", value: state.profile.country_code }, { root: true });
    dispatch(
      "validator/validate",
      { field: "primary_language", value: state.profile.primary_language },
      { root: true }
    );
    dispatch("password/validatePassword", null, { root: true });
    return rootState.validator.errors?.length === 0;
  }
};
